import React, {useEffect, useState} from "react";
import AliceCarousel from 'react-alice-carousel';
import { downloadFile } from "../../services/FileService";

const PhotoCarousel = (props) => {
    let [photos, setPhotos] = useState()
    useEffect(() => {
        let currentPhotos = [];
        props.files && props.files.forEach(p => {
            downloadFile(p.url).then(f => {
                currentPhotos.push(<img key={f.url} src={f} className="file-img" onDragStart={handleDragStart} />)
                setPhotos(currentPhotos)
            })
        })
        
    },[props.files])

    const handleDragStart = (e) => e.preventDefault();

    if (!photos) return null;
    console.log(photos)

    return (
        <AliceCarousel key={photos.length} items={photos} disableDotsControls={true} disableButtonsControls={true} activeIndex={1} />
    )
}

export default PhotoCarousel;